import { useState, useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { api } from '../utils/api';

/**
 * Returns whether the current user is an admin (GET /api/admin/check).
 * Only checks when user is authenticated to avoid unnecessary 401 errors.
 * @returns {{ isAdmin: boolean, loading: boolean }}
 */
export function useAdmin() {
  const { getToken, isSignedIn } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      // Only check admin status if user is signed in
      if (!isSignedIn) {
        if (!cancelled) {
          setIsAdmin(false);
          setLoading(false);
        }
        return;
      }
      try {
        const res = await api('/api/admin/check', { getToken });
        const data = await res.json().catch(() => ({}));
        if (!cancelled) {
          setIsAdmin(res.ok && !!data.isAdmin);
        }
      } catch {
        if (!cancelled) setIsAdmin(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [getToken, isSignedIn]);

  return { isAdmin, loading };
}
